import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { FavoritesMenuComponent } from '../favorites-menu/favorites-menu.component';
import { InstancesChanges, NgxTippyProps, NgxTippyService } from 'ngx-tippy-wrapper';
import { AuthService } from '../../../components/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DropDownMenuModel, MenuUIModel, NotificationMessageType } from '../../models/models';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../app/models/classes';
import { filter, lastValueFrom, Subject, Subscription, takeUntil } from 'rxjs';
import { dirtySaveActionState, navbarTitleUpdated, suggestionUpdated, userIdState, userPermissionLoaded, userProfileUpdated } from '../../../../app/store/store.selector';
import { UserInfoService } from '../../../services/user-info.service';
import { FetchEmployeeListItem, GsConnectNotificationItem, InternalTitlePermissionListItem, InternalUserItem } from '../../../../../../goldstar-share/src/app/api-data/ng-openapi-gen-next/models';
import { MyDayPopupComponent } from './my-day-popup/my-day-popup.component';
import { TippyComponentInstance } from '../../../components/shared/enum';
import { RoutePathResolverService } from '../../services/route-path-resolver.service';
import { PermissionService } from '../../../../../../goldstar-share/src/app/services/permission.service';
import _ from 'lodash';
import { ConfirmationPopupService } from '../../services/confirmation-popup.service';
import { ErrorHandlingService } from '../../../../../../goldstar-share/src/app/services/error-handling.service';
import { FeedbackPopupComponent } from './feedback-popup/feedback-popup.component';
import { NotificationService } from '../stand-alone/notifications/services/notification.service';
import { ImpersonateUserComponent } from '../../../components/impersonate/impersonate-user/impersonate-user.component';
import { S3FileService } from '../../../../../../goldstar-share/src/app/services/s3file-service';
import { FeedbackService } from '../stand-alone/feedback/services/feedback.service';
import { SuggestionUpdateAction, UserProfileUpdateAction } from '../../../../app/store/store.actions';
import { GsConnectNotificationComponent } from './gs-connect-notification/gs-connect-notification.component';
import { GsConnectService } from '../stand-alone/gs-connect/services/gs-connect.service';
import { ApiService } from '../../../../../../goldstar-share/src/app/api-data/ng-openapi-gen-next/services/api.service';
import { DashboardMenuService } from '../../services/dashboard-menu.service';
import { WebSocketEnvelope, WebSocketService } from '../stand-alone/notifications/services/websocket.service';
import { ChatSidecarService } from '../stand-alone/ai-chat/services/chat-sidecar.service';

type EmployeeWithImage = {
	imageSrc?: string;
} & FetchEmployeeListItem;
@Component({
	selector: 'app-top-navbar',
	templateUrl: './top-navbar.component.html',
	styleUrls: ['./top-navbar.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class TopNavbarComponent implements OnInit, OnDestroy {
	public userHasImpersonatePermission!: boolean;
	public tippyProps: NgxTippyProps = {
		trigger: 'click',
		interactive: true,
		zIndex: 9999,
	};
	public readonly favoriteComponent = FavoritesMenuComponent;
	public readonly myDayPopupComponent = MyDayPopupComponent;
	public readonly feedbackPopupComponent = FeedbackPopupComponent;
	public readonly gsConnectNotificationPopupComponent = GsConnectNotificationComponent;
	@Input() sideBarExpanded!: boolean;

	public loggedInUser?: InternalUserItem;
	private allUsers: InternalUserItem[] = [];
	public title!: string;
	public profileMenuList: DropDownMenuModel[] = [];
	public navigationMenuList: DropDownMenuModel[] = [];

	public componentGUID!: string | undefined;

	public hasFeedbackPermission!: boolean;
	public hasAiChatPermission: boolean = false;

	public baseMenuModels: DropDownMenuModel[] = [
		{
			name: 'Profile',
			icon: 'bx-user',
			onClick: this.onProfileMenuClick.bind(this),
		},
		{
			name: 'Logout',
			icon: 'bx-left-arrow-circle',
			onClick: this.onProfileMenuClick.bind(this),
		},
	];
	hasUnsavedChanges: boolean = false;
	public readonly addFeedbackPermissionRoute: string = '/dashboard/add-question-comment-suggestion';
	gsConnectVisible: boolean = false;
	userSearchVisible: boolean = false;
	isFeedbackInitialized: boolean = false;
	isGsConnectNotificationInitialized: boolean = false;
	isMyDayInitialized: boolean = false;
	isFavoritePopupInitialized: boolean = false;
	defaultProfileImage: string = '../../../../../../assets/images/Trb-latest-svg/trb-silhouette-transparent.png';
	public userProfileImage: string = this.defaultProfileImage;
	private ngUnSubscribe$ = new Subject<void>();
	hasSuggestions: boolean = false;
	hasPostNotification: boolean = false;

	//TODO: ENABLE AGAIN AFTER FINISHING WITH SOCKETS API DIALPAD
	// private wsSub!: Subscription;
	public isUserOnCall: boolean = false;
	public currentCallId?: string = undefined;
	public dialPadUserId: InternalUserItem['internalUserDialPadId'] = undefined;

	public isSearchDisabled = true;
	public searchValues: string[] = [];
	public searchResults: EmployeeWithImage[] = [];
	public hasMoreResults: boolean = false;
	public noResultsFound: boolean = false;

	@ViewChild('topNavbarSearch') topNavbarSearch!: ElementRef;
	@ViewChild('topNavbarSearchWrapper') topNavbarSearchWrapper!: ElementRef;

	constructor(
		private authService: AuthService,
		public dialog: MatDialog,
		private router: Router,
		private store: Store<AppState>,
		private tippyService: NgxTippyService,
		private userInfoService: UserInfoService,
		private routePathResolver: RoutePathResolverService,
		private permissionService: PermissionService,
		private notificationService: NotificationService,
		private confirmationPopUpService: ConfirmationPopupService,
		private fileService: S3FileService,
		private feedbackService: FeedbackService,
		private gsConnectService: GsConnectService,
		private apiServiceV2: ApiService,
		private menuService: DashboardMenuService,
		private webSocketService: WebSocketService,
		private renderer: Renderer2,
		private errorHandlingService: ErrorHandlingService,
		private chatSidecarService: ChatSidecarService
	) {}

	ngAfterViewInit() {
		this.renderer.listen('document', 'click', (e: Event) => {
			const clickedInside = this.topNavbarSearchWrapper?.nativeElement?.contains(e.target);
			if (!clickedInside) {
				this.searchValues = [];
				this.searchResults = [];
				this.noResultsFound = false;
				this.hasMoreResults = false;
			}
		});
	}

	async ngOnInit(): Promise<void> {
		this.initializeSubscriptions();

		this.store
			.select(dirtySaveActionState)
			.pipe(takeUntil(this.ngUnSubscribe$))
			.subscribe((hasUnSavedChanges) => {
				this.hasUnsavedChanges = hasUnSavedChanges ?? false;
			});
		this.tippyService.instancesChanges.pipe(takeUntil(this.ngUnSubscribe$)).subscribe((changes: InstancesChanges) => {
			if (changes.reason == 'setInstance') {
				switch (changes.name) {
					case TippyComponentInstance.Feedback:
						let feedback = this.tippyService.getInstance(TippyComponentInstance.Feedback);
						if (!feedback?.state.isShown) {
							setTimeout(() => {
								this.tippyService.show(TippyComponentInstance.Feedback);
							}, 10);
						}
						break;
					case TippyComponentInstance.MyDay:
						let myDayInstance = this.tippyService.getInstance(TippyComponentInstance.MyDay);
						if (!myDayInstance?.state.isShown) {
							this.tippyService.show(TippyComponentInstance.MyDay);
						}
						break;
					case TippyComponentInstance.Favourite:
						let favInstance = this.tippyService.getInstance(TippyComponentInstance.Favourite);
						if (!favInstance?.state.isShown && this.isFavoritePopupInitialized) {
							// Here the string is the tippy instance name
							this.tippyService.show(TippyComponentInstance.Favourite);
						}
						break;
					case TippyComponentInstance.GsConnect:
						let gsConnectInstance = this.tippyService.getInstance(TippyComponentInstance.GsConnect);
						if (!gsConnectInstance?.state.isShown && this.isGsConnectNotificationInitialized) {
							// Here the string is the tippy instance name
							this.tippyService.show(TippyComponentInstance.GsConnect);
						}
						break;
					default:
						break;
				}
			}
		});

		const currentLoggedInUser = await this.userInfoService.getCurrentLoggedInUser();

		//Sets the current user's dialpadUserID to use across multiple api calls.
		this.dialPadUserId = currentLoggedInUser.internalUserDialPadId;

		//TODO: ENABLE AGAIN AFTER FINISHING WITH SOCKETS API DIALPAD
		// this.wsSub = this.webSocketService.messages$
		// 	.pipe(
		// 		filter(
		// 			(msg) =>
		// 				msg?.message?.toUserGUID === currentLoggedInUser.internalUserGUID &&
		// 				(msg?.message?.type === NotificationMessageType.Notification || msg?.message?.type === NotificationMessageType.Chat)
		// 		)
		// 	)
		// 	.subscribe({
		// 		next: (msg) => this.handleWebsocketMessage(msg),
		// 		error: (err) => console.error('WS stream error', err),
		// 	});
	}

	//TODO: ENABLE AGAIN AFTER FINISHING WITH SOCKETS API DIALPAD
	// private handleWebsocketMessage(msg: WebSocketEnvelope) {
	// 	console.log('TOP NAVBAR WEBSOCKET MESSAGE: ', msg);
	// 	const message = msg.message;

	// 	if (!message) return;

	// 	const body = JSON.parse(message.messageBody);

	// 	console.log('TOP NAVBAR MESSAGE BODY: ', body);
	// 	console.log('TOP NAVBAR BODY STATE AND CALL ID: ', body.state, body.call_id);

	// 	const isConnected = body.state === 'connected';

	// 	this.isUserOnCall = isConnected;
	// 	this.currentCallId = isConnected ? body.call_id : undefined;
	// }

	initializeSubscriptions() {
		// SUBSCRIPTION FOR NAV BAR TITLE UPDATE EVENT
		this.store
			.select(navbarTitleUpdated)
			.pipe(takeUntil(this.ngUnSubscribe$))
			.subscribe((title: string) => {
				this.title = title;
			});
		this.store
			.select(userProfileUpdated)
			.pipe(takeUntil(this.ngUnSubscribe$))
			.subscribe(async (isUpdated: boolean) => {
				if (isUpdated) {
					let user = this.userInfoService.currentLoggedInUser.value;
					if (user.smallPictureS3FileGUID) {
						let fileToLoad = await this.fileService.downloadS3FilePreSignedUrl(
							{
								s3FileGUID: user.smallPictureS3FileGUID,
								createDownloadLink: false,
							},
							false
						);
						if (fileToLoad?.file) {
							this.userProfileImage = URL.createObjectURL(fileToLoad?.file);
						} else {
							this.userProfileImage = this.defaultProfileImage;
						}
					} else {
						this.userProfileImage = this.defaultProfileImage;
					}
					this.store.dispatch(
						UserProfileUpdateAction({
							userProfileUpdated: false,
						})
					);
				}
			});
		// SUBSCRIPTION FOR USER LOADED EVENT

		this.userInfoService.currentLoggedInUser.pipe(takeUntil(this.ngUnSubscribe$)).subscribe(async (user: InternalUserItem) => {
			if (user) {
				if (user.internalUserGUID != this.userInfoService.loggedInUserGUID) {
					this.userInfoService.loggedInUserGUID = user.internalUserGUID ?? '';
				}
				this.gsConnectService.postNotificationList.next([]);
				if (user.smallPictureS3FileGUID) {
					let fileToLoad = await this.fileService.downloadS3FilePreSignedUrl(
						{
							s3FileGUID: user.smallPictureS3FileGUID,
							createDownloadLink: false,
						},
						true
					);
					if (user.internalUserGUID == this.userInfoService.loggedInUserGUID) {
						if (fileToLoad?.file) {
							this.userProfileImage = URL.createObjectURL(fileToLoad?.file);
						} else {
							this.userProfileImage = this.defaultProfileImage;
						}
					} else {
						return;
					}
				} else {
					this.userProfileImage = this.defaultProfileImage;
				}
				this.loggedInUser = user ?? undefined;
				this.navigationMenuList = this.prepareNavigationMenu();
				this.checkInitialMySuggestionsCount();
				this.getGsConnectNotification();
			}
		});

		// SUBSCRIPTION WHEN USER IS LOADED
		this.store
			.select(userIdState)
			.pipe(takeUntil(this.ngUnSubscribe$))
			.subscribe(async (userId) => {
				if (userId) {
					this.navigationMenuList = this.prepareNavigationMenu();
					// if (this.allUsers && this.allUsers.length > 0) {
					// 	this.loggedInUser = this.allUsers.find((x) => x.email === userId)?.name ?? '';
					// }
				}
			});

		// SUBSCRIBING TO USER PERMISSION LOADED
		this.store
			.select(userPermissionLoaded)
			.pipe(takeUntil(this.ngUnSubscribe$))
			.subscribe(async (_allPermission: InternalTitlePermissionListItem[] | undefined) => {
				if (_allPermission) {
					this.userHasImpersonatePermission = await this.permissionService.userHasPermissionByKey('AdminMenuGroup.AllowUserImpersonation', this.authService.userId);
					this.profileMenuList = this.authService.isActiveImpersonation ? this.prepareActiveImpersonationMenu() : this.prepareInactiveImpersonationMenu();
					this.hasFeedbackPermission = await this.permissionService.userHasPermission(this.addFeedbackPermissionRoute);
				}
				this.hasAiChatPermission = await this.permissionService.userHasPermissionByKey('AiChat.View');
				this.gsConnectVisible = await this.permissionService.userHasPermission('/dashboard/view-gs-connect');
				this.userSearchVisible = await this.permissionService.userHasPermission('/dashboard/view-user-search');
			});
		this.store
			.select(suggestionUpdated)
			.pipe(takeUntil(this.ngUnSubscribe$))
			.subscribe((updated: boolean) => {
				if (updated) {
					this.checkMySuggestionsCount();
					this.store.dispatch(
						SuggestionUpdateAction({
							suggestionUpdated: false,
						})
					);
				}
			});
		this.gsConnectService.postNotificationList.pipe(takeUntil(this.ngUnSubscribe$)).subscribe((list: GsConnectNotificationItem[]) => {
			if (list.length > 0) {
				this.hasPostNotification = list.filter((t) => t.hasNewNotification).length > 0;
			} else {
				this.hasPostNotification = false;
			}
		});
	}

	/**
	 * Click event on favorite menu item clicked. It shows tippy favorite popup
	 */
	showFavoritePopup = () => {
		this.isFavoritePopupInitialized = true;
	};
	disableParentTippyComponent(className: string) {
		const relativePos = document.getElementsByClassName(className)[0];
		relativePos?.classList?.add('pos-relative');
	}

	showMyDayPopup() {
		this.isMyDayInitialized = true;
	}
	showFeedbackPopup() {
		//this.isFeedbackInitialized = true;
		let feedbackComponentGUID = this.routePathResolver.resolveRouterUrlGUIDFromComponentName('ViewFeedbackComponent');
		this.router.navigate(['', feedbackComponentGUID]);
	}
	openGsConnectPage() {
		//if (this.gsConnectService.postNotificationList) {
		// this.isGsConnectNotificationInitialized = true;
		let gsConnectComponentGUID = this.routePathResolver.resolveRouterUrlGUIDFromComponentName('GsConnectComponent');
		this.router.navigate(['', gsConnectComponentGUID]);
		//} else {
		//let gsConnectComponentGUID = this.routePathResolver.resolveRouterUrlGUIDFromComponentName('GsConnectComponent');
		//this.router.navigate(['', gsConnectComponentGUID]);
		//}
	}
	onProfileMenuClick(menuName: string) {
		switch (menuName) {
			case 'Profile':
				this.componentGUID = this.routePathResolver.resolveRouterUrlGUIDFromComponentName('ProfileComponent');
				this.router.navigate(['', this.componentGUID]);
				break;
			case 'Logout':
				this.onLogoutUser();
				break;
			case 'Impersonate':
				this.onImpersonate();
				break;
			case 'Stop-Impersonate':
				this.onStopUserImpersonation();
				break;
			default:
		}
	}

	onLogoutUser() {
		if (this.hasUnsavedChanges) {
			this.confirmationPopUpService.showConfirmationModal({
				title: '',
				message: '',
				onConfirm: () => {
					this.authService.logout();
				},
			});
		} else {
			this.authService.logout();
		}
	}

	onImpersonate() {
		if (this.hasUnsavedChanges) {
			this.confirmationPopUpService.showConfirmationModal({
				title: '',
				message: '',
				onConfirm: () => {
					this.openImpersonateDialog({});
				},
			});
		} else {
			this.openImpersonateDialog({});
		}
	}
	openImpersonateDialog(data: any) {
		const dialogRef = this.dialog.open(ImpersonateUserComponent, {
			width: '450px',
			data: data,
		});
		dialogRef.afterClosed().subscribe(async (result: any) => {
			if (result.data) {
				this.router.navigate(['']);
			}
		});
	}
	onStopUserImpersonation() {
		if (this.hasUnsavedChanges) {
			this.confirmationPopUpService.showConfirmationModal({
				title: '',
				message: '',
				onConfirm: () => {
					this.authService.stopImpersonation(this.authService.userId);
					this.router.navigate(['']);
				},
			});
		} else {
			this.authService.stopImpersonation(this.authService.userId);
			this.router.navigate(['']);
		}
	}

	prepareActiveImpersonationMenu(): DropDownMenuModel[] {
		let menuModels: DropDownMenuModel[] = [];
		menuModels = _.cloneDeep(this.baseMenuModels);
		menuModels.push({
			name: 'Stop-Impersonate',
			icon: 'bx-user',
			onClick: this.onProfileMenuClick.bind(this),
		});
		return menuModels;
	}

	prepareInactiveImpersonationMenu(): DropDownMenuModel[] {
		let menuModels: DropDownMenuModel[] = [];
		menuModels = _.cloneDeep(this.baseMenuModels);
		if (this.userHasImpersonatePermission) {
			const hasItem = menuModels.find((x) => x.name === 'Impersonate');
			if (!hasItem) {
				menuModels.push({
					name: 'Impersonate',
					icon: 'bx-user',
					onClick: this.onProfileMenuClick.bind(this),
				});
			}
		}
		return menuModels;
	}

	prepareNavigationMenu(): DropDownMenuModel[] {
		const menuModel: DropDownMenuModel[] = [
			{
				name: 'Settings',
				icon: 'bx-user',
				onClick: this.onProfileMenuClick.bind(this),
			},
			{
				name: 'Favorites',
				icon: 'bx-left-arrow-circle',
				onClick: this.onProfileMenuClick.bind(this),
			},
			{
				name: 'Todo List',
				icon: 'bx-user',
				onClick: this.onProfileMenuClick.bind(this),
			},
			{
				name: 'Notifications',
				icon: 'bx-user',
				onClick: this.onProfileMenuClick.bind(this),
			},
		];
		return menuModel;
	}

	openChatSidecar(): void {
		this.chatSidecarService.open();
	}

	ngOnDestroy(): void {
		this.ngUnSubscribe$.next();
		this.ngUnSubscribe$.unsubscribe();

		//TODO: ENABLE AGAIN AFTER FINISHING WITH SOCKETS API DIALPAD
		// this.wsSub?.unsubscribe();
	}
	async getGsConnectNotification() {
		let loggedInUser = this.userInfoService.currentLoggedInUser.value;
		const response = await this.gsConnectService.fetchPostNotifications(loggedInUser.internalUserGUID ?? '');
		if (response.isSuccess && response.data && response.data?.length > 0) {
			this.hasPostNotification = response.data.filter((t) => t.hasNewNotification).length > 0;
		} else {
			this.hasPostNotification = false;
		}
	}
	async checkInitialMySuggestionsCount() {
		let loggedInUser = this.userInfoService.currentLoggedInUser.value;
		const response = await this.feedbackService.fetchAllSuggestion(loggedInUser);
		this.hasSuggestions = response.isSuccess && response.data == true;
	}
	async checkMySuggestionsCount() {
		this.hasSuggestions = this.feedbackService.showArchivedSuggestionCount || this.feedbackService.showMySuggestionCount || this.feedbackService.showSuggestionReceivedCount;
	}

	/**
	 * mauriciod: I'm not a fan of this at all...
	 * all of the following functions are an exact copy from
	 * employee-directory.component.ts and
	 * employee-filters.component.ts
	 * TODO: They could be extracted into a service (?).
	 */
	async searchEmployees({ newSearch = true }: { newSearch?: boolean }) {
		if (newSearch) {
			//Reset results with every search.
			this.searchResults = [];
			this.noResultsFound = false;
		}

		const searchString = this.searchValues?.join(' ').trim() ?? '';

		const response = await lastValueFrom(
			this.apiServiceV2.getEmployeeSearchResults({
				body: {
					searchString,
					locations: [],
					departments: [],
					divisions: [],
					jobTitles: [],
					limit: 5,
					offset: 0,
					currentPageNumber: 0,
				},
			})
		);

		if (!response.isSuccess || !response.data || !response.data.items || !response.data.items[0]) {
			return;
		}

		const responseItems = response.data.items[0] as FetchEmployeeListItem[];

		this.hasMoreResults = responseItems.length > 4;

		const hasItems = responseItems.length > 0;
		if (!hasItems) {
			this.noResultsFound = true;
			this.searchResults = [];
		} else {
			const newSearchResults = [...this.searchResults];
			newSearchResults.push(...(response.data?.items?.[0] as EmployeeWithImage[]));
			this.searchResults = [...newSearchResults.slice(0, 5)];
			await this.setAllEmployeeImages(newSearchResults, responseItems.length);
		}
	}

	async setAllEmployeeImages(searchResults: EmployeeWithImage[], resultsOffset: number) {
		const realOffset = this.searchResults.length - resultsOffset;

		await Promise.all(
			searchResults.slice(resultsOffset * -1).map(async (employee, i) => {
				const employeeCopy = { ...employee };
				const index = realOffset + i;

				if (employee.profileImageS3FileGUID && !employee.hasOwnProperty('imageSrc')) {
					let fileDownloadResult = await this.fileService.downloadS3FilePreSignedUrl(
						{
							s3FileGUID: employee.profileImageS3FileGUID,
							createDownloadLink: true,
						},
						true
					);
					if (fileDownloadResult?.file) {
						employeeCopy.imageSrc = URL.createObjectURL(fileDownloadResult.file);
					}

					this.searchResults[index] = { ...employeeCopy };
				}
			})
		);
	}

	onSearch() {
		this.setSearchDisabled();

		//Must wait for all filters to be submitted first
		if (!this.isSearchDisabled) {
			this.searchEmployees({ newSearch: true });
		}
	}

	setSearchDisabled() {
		let disabled = false;

		if (!this.searchValues || this.searchValues.length === 0) {
			disabled = true;
		}

		this.isSearchDisabled = disabled;
	}

	onFilterSelected(filterName: string): void {
		document.getElementById(filterName)?.focus();
	}

	onKey(event: Event) {
		const keyboardEvent = event as KeyboardEvent;
		const key = keyboardEvent.code;

		const inputElement = this.topNavbarSearch.nativeElement as HTMLInputElement;

		const currentInputValue = inputElement.value.trim();
		const isInputValueEmpty = currentInputValue.length === 0;

		this.setSearchDisabled();

		if (key === 'Enter' || key === 'Space' || key === 'NumpadEnter' || event instanceof PointerEvent) {
			// ADD
			if (!isInputValueEmpty) {
				this.onSearchChangeEvent(currentInputValue);
			}

			inputElement.value = '';

			return;
		} else if (key === 'Backspace' || key === 'Delete') {
			// DELETE LAST
			if (isInputValueEmpty) {
				this.onSearchRemoveLast();
				event.preventDefault();
			}

			return;
		}
	}

	onSearchChangeEvent(inputValue: string): void {
		const newSearchValue = inputValue.trim();

		//Transforms all contiguous spaces into a single space
		//Removes spaces before and after the string
		//Splits it into multiple values in case a space managed to get through
		const cleanValue = newSearchValue.replace(/\s+/g, ' ').trim().split(' ');

		this.searchValues = [...this.searchValues, ...cleanValue];
		this.topNavbarSearch.nativeElement.value = '';
	}

	onSearchRemove(removeIndex: number) {
		let newSearchValues: string[] = [...this.searchValues];

		newSearchValues.splice(removeIndex, 1);

		this.searchValues = [...newSearchValues];

		if (this.searchValues.length === 0) {
			this.noResultsFound = false;
			this.searchResults = [];
		}
	}

	onSearchRemoveLast(): void {
		if (this.searchValues && this.searchValues.length > 0) {
			this.onSearchRemove(this.searchValues.length - 1);
		}
	}

	/**
	 * mauriciod: I don't like this pattern in Angular, too much boilerplate
	 * for one single function.
	 * Had to do this to conditionally render a cancel button on the app-chip
	 * component. HTML Templates don't allow arrow functions so I had to create
	 * this "helper" function.
	 */
	getSearchRemoveHandler(index: number): (e: MouseEvent) => void {
		return (event: MouseEvent) => {
			event.stopPropagation();
			this.onSearchRemove(index);
		};
		// return () => this.onSearchRemoveEvent(index);
	}

	navigateToEmployeeDirectory(selectedEmployee?: any) {
		//navigate to "Employee directoy"
		const employeeDirectoryMenuGroup = this.menuService.getMenuItemByName('Employee Directory') as MenuUIModel;

		const baseUrl = document.location.origin;
		const employeeDirectoryUrl = employeeDirectoryMenuGroup?.urlGUID;

		const searchString = this.searchValues.join('_');
		let queryParams = `searchValue=${searchString}`;

		if (selectedEmployee !== undefined) {
			queryParams += `&selectedEmployeeGUID=${selectedEmployee.internalUserGUID}`;
		}

		const fullUrl = `${baseUrl}/${employeeDirectoryUrl}?${queryParams}`;

		window.open(fullUrl, '_blank');
	}

	callUser = async ({ employeePhoneNumber }: { employeePhoneNumber: string }) => {
		const formattedPhoneNumber = `+1${employeePhoneNumber.split('-').join('')}`;

		if (!this.dialPadUserId) return;

		//If user is already on call transfer
		if (this.isUserOnCall && this.currentCallId) {
			await lastValueFrom(this.apiServiceV2.postDialPadCallTransfer({ body: { phoneNumber: formattedPhoneNumber, currentCallId: this.currentCallId } }));
		} else {
			//Else, call
			const response = (await lastValueFrom(this.apiServiceV2.postDialPadCall({ body: { dialPadUserId: this.dialPadUserId, phoneNumber: formattedPhoneNumber } }))) as any;

			const responseItems = response.data?.items ?? [];

			//If user is already on a call.
			if (
				responseItems.length > 0 &&
				responseItems[0].hasOwnProperty('error') &&
				responseItems[0].error.hasOwnProperty('message') &&
				responseItems[0].error.message === 'User is currently on a call'
			) {
				this.errorHandlingService.showErrorMessage('Unable to use Call function while on another Dialpad call.');
			}
		}
	};

	get getIsSubmitDisabled() {
		if (this.searchValues.length > 0 || this.topNavbarSearch?.nativeElement.value.trim().length > 0) return false;

		return true;
	}
}
